import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import TextTruncate from 'react-text-truncate';

import { chainDecorators, memoized } from '../../utils/ReactUtils'

import styles from './styles'

const decorators = [
  memoized,
]

function TextShowMore(props) {
  const { className, text, showMoreText, line, truncateText } = props

  const [hidden, setHidden] = useState(true)

  const handleClick = () => setHidden(false)

  return (
    <div className={classnames('text-show-more-container', className)}>
      {hidden && <TextTruncate line={line} truncateText={truncateText} text={text} textTruncateChild={<button className="button" onClick={handleClick}>{showMoreText}</button>} />}
      {!hidden && <p className="text">{text}</p>}
      <style jsx>{styles}</style>
    </div>
  )
}

TextShowMore.propTypes = {
  text: PropTypes.string.isRequired,
  showMoreText: PropTypes.string.isRequired,
  line: PropTypes.number,
  truncateText: PropTypes.string
}

TextShowMore.defaultProps = {
  text: '',
  showMoreText: '',
  line: 3,
  truncateText: '...'
}

TextShowMore = chainDecorators(decorators, TextShowMore)

export default TextShowMore
